module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/leather_e44a0b.jpg";